module.exports = __webpack_public_path__ + "img/the-soul-of-cincy-2x.90179018.png";